import { Box, Typography } from '@mui/material';
import { ReactComponent as NoteIcon } from 'assets/note-search.svg';

const NoItems = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center',
      height: '600px',
      gap: '12px',
      paddingTop: '100px',
    }}
  >
    <Box sx={{ marginBottom: '12px' }}>
      <NoteIcon />
    </Box>
    <Typography variant='responsiveHeading3'>No Results Found</Typography>
    <Typography variant='responsiveBody3'>
      We couldn’t find any items matching your search. Try adjusting your keywords.
    </Typography>
  </Box>
);

export default NoItems;
